import Axios from 'axios'
const AUTH_API_HOST = process.env.VUE_APP_AUTH_API_HOST
const MemberService = {
  /**
   * @description Get member data
   *
   * @returns {object}
   */
  getMe(token, params) {
    const getMeURL = `${AUTH_API_HOST}/api/me`
    return Axios
      .request({
        method: 'GET',
        headers: {
          'Authorization': 'Bearer ' + token
        },
        url: getMeURL
      })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: [] }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  getUser(token, id) {
    const getUserURL = `${AUTH_API_HOST}/api/users/${id}`
    return Axios
      .request({
        method: 'GET',
        headers: {
          'Authorization': 'Bearer ' + token
        },
        url: getUserURL
      })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: [] }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  updateUser(token, userId, data) {
    const updateUserURL = `${AUTH_API_HOST}/api/users/${userId}`
    return Axios
      .request({
        method: 'POST',
        url: updateUserURL,
        headers: {
          // 'content-type': 'application/x-www-form-urlencoded',
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'multipart/form-data'
        },
        data: data
      })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: [] }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  }
}
export default MemberService
